var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('button',_vm._g(_vm._b({class:{
        'v-btn v-btn--is-elevated v-btn--fab v-btn--has-bg v-btn--round theme--light v-size--x-small': true,
        'ma-1': true,
        'frame-button': true,
        selected: _vm.selectedFrame === _vm.frame,
      },style:({ background: ("url('" + (_vm.frame.swatchImage) + "'") }),attrs:{"disabled":_vm.flagFrame},on:{"click":function($event){return _vm.$emit('selected-frame', _vm.frame)}}},'button',attrs,false),on))]}}])},[_c('span',[_vm._v(" "+_vm._s(_vm.frame.text)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }